<template>
  <div class="setting-box">
    <cx-check-box :value.sync="visualMapIcon">显示映射图标</cx-check-box>
    <!-- <cx-check-box :value.sync="showIconText" class="mt16">显示图标文字</cx-check-box> -->
    <cx-check-box :value.sync="dragHandleIcon" class="mt16">显示拖拽手柄</cx-check-box>
    <div class="verticallyCenter mt16">
      <span class="mr16">显示位置</span>
      <div class="verticallyCenter mr12 flex1">
        <single-input
          style="width: 100%"
          :value.sync="mapLeft"
          inputSuffixs="横"
        />
<!--        <el-input type="number" v-model="mapLeft" style="width: 100%" @focus="getFocus($event)">-->
<!--          <template slot="suffix">-->
<!--            <span class="suffix_text">横</span>-->
<!--          </template>-->
<!--        </el-input>-->
      </div>
      <div class="verticallyCenter flex1">
        <single-input
          style="width: 100%"
          :value.sync="mapTop"
          inputSuffixs="纵"
        />
<!--        <el-input type="number" v-model="mapTop" style="width: 100%" @focus="getFocus($event)">-->
<!--          <template slot="suffix">-->
<!--            <span class="suffix_text">纵</span>-->
<!--          </template>-->
<!--        </el-input>-->
      </div>
    </div>
    <cx-select class="mt16" title="图标类型" :selectOptions="symbolType" :value.sync="mapIconType" />
    <cx-select class="mt16" title="图标方向" :selectOptions="symbolOrient" :value.sync="mapIconOrient" />
    <p class="mt16">最大值</p>
    <slider-and-input
      class="mt8"
      :value.sync="mapMax"
      titlePosition="singleLine"
      :sliderMax="5000"
      suffix=""
    />
    <p class="mt16">最小值</p>
    <slider-and-input
      class="mt8"
      :value.sync="mapMin"
      titlePosition="singleLine"
      :sliderMax="1000"
      suffix=""
    />
    <color-picker class="mt16 colorchoose" :color.sync="mapEndColor" title="最大值颜色" />
    <color-picker class="mt16 colorchoose" :color.sync="mapStartColor" title="最小值颜色" />
    <tooltipSetting :options="options" class="mt16" :show-auto-play-setting="false"/>
  </div>
</template>

<script>
import tooltipSetting from "../../../map/toolbars/mapSettings/tooltipSetting"
export default {
  components: {
    tooltipSetting
  },
  props: {
    options: Object
  },
  data() {
    return {
      symbolType: [
        { label: "连续", value: "continuous" },
        { label: "分段", value: "piecewise" }
      ],
      symbolOrient: [
        { label: "水平", value: "horizontal" },
        { label: "竖直", value: "vertical" }
      ]
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    chartOption() {
      return this.options.chartOption
    },
    visualMapIcon: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "show", "show", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.show", false)
      }
    },
    dragHandleIcon: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "calculable", "calculable", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.calculable", false)
      }
    },
    showIconText: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap.textStyle, "height", "height", 0)
      },
      set(val) {
        this.$changeOptionsEV(val ? 10 : 0, "chartOption.visualMap.textStyle.height", false)
      }
    },
    mapMax: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "max", "max", 1000)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.max", false)
      }
    },
    mapMin: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "min", "min", 0)
      },
      set(val) {
        if (val >= this.mapMax) {
          this.$changeOptionsEV(this.mapMax, "chartOption.visualMap.min", false)
        } else {
          this.$changeOptionsEV(val, "chartOption.visualMap.min", false)
        }
      }
    },
    mapLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "left", "left", 10)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.left", false)
      }
    },
    mapTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "top", "top", 300)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.top", false)
      }
    },
    mapIconType: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "type", "type", "continuous")
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.type", false)
      }
    },
    mapIconOrient: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "orient", "orient", "horizontal")
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.orient", false)
      }
    },
    mapStartColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "mapStartColor", "mapStartColor", "#1770FF")
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.mapStartColor", false)
        this.$changeOptionsEV(val, "chartOption.visualMap.inRange.color.0", false)
      }
    },
    mapEndColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption.visualMap, "mapEndColor", "mapEndColor", "#E8684A")
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.visualMap.mapEndColor", false)
        this.$changeOptionsEV(val, "chartOption.visualMap.inRange.color.1", false)
      }
    }
  },
  methods: {
    getFocus(event) {
      event.currentTarget.select()
    }
  }
}
</script>

<style scoped>
.setting-box {
  padding: 16px 16px;
}
.colorchoose/deep/ > div > label {
  width: 70px;
}
.colorchoose/deep/ > div > div {
  flex: 0;
  width: calc(100% - 86px);
}
</style>
